import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import type { SortDir } from './table_sort';

interface SortHeaderProps {
    label: string;
    sortKey: string;
    activeKey: string | null;
    dir: SortDir;
    onSort: (key: string, textual?: boolean) => void;
    /** Coluna de texto: 1º clique ordena asc. */
    textual?: boolean;
    align?: 'left' | 'right';
    /** Cor do rótulo quando inativo (ex.: cor do grupo de colunas). */
    tint?: string;
}

/** Cabeçalho de coluna clicável para ordenar a tabela. */
export function SortHeader({ label, sortKey, activeKey, dir, onSort, textual, align = 'right', tint }: SortHeaderProps) {
    const active = activeKey === sortKey;
    return (
        <button
            type="button"
            onClick={() => onSort(sortKey, textual)}
            title={`Ordenar por ${label}`}
            className={`flex items-center gap-0.5 whitespace-nowrap text-[10px] font-medium uppercase tracking-[0.1em] transition-colors ${
                active ? 'text-foreground' : tint || 'text-muted-foreground hover:text-foreground'
            } ${align === 'right' ? 'w-full justify-end text-right' : 'text-left'}`}
        >
            {label}
            {active ? (
                dir === 'desc' ? <ArrowDown className="h-2.5 w-2.5 shrink-0" /> : <ArrowUp className="h-2.5 w-2.5 shrink-0" />
            ) : (
                <ArrowUpDown className="h-2.5 w-2.5 shrink-0 opacity-40" />
            )}
        </button>
    );
}
